export default "__VITE_ASSET__LcugvEly__"